// Phase 8c — facility-bill-rate-override admin schemas (operator-only).
import { z } from 'zod';
import { ShiftSettingSchema, ShiftTimeBucketSchema } from './enums.schema.js';
import { RateIsoDateSchema, RateLeadTimeOverrideSchema, RateMoneyAmountSchema, RateReasonSchema, } from './_shared.schema.js';
export const AdminFacilityBillRateOverrideCreateRequestSchema = z
    .object({
    facilityId: z.string().uuid(),
    roleId: z.string().uuid(),
    setting: ShiftSettingSchema,
    shiftTimeBucket: ShiftTimeBucketSchema.nullable(),
    billRateOverride: RateMoneyAmountSchema,
    effectiveFrom: RateIsoDateSchema,
    reason: RateReasonSchema,
})
    .and(RateLeadTimeOverrideSchema);
export const AdminFacilityBillRateOverrideSupersedeRequestSchema = z
    .object({
    newBillRateOverride: RateMoneyAmountSchema,
    effectiveFrom: RateIsoDateSchema,
    reason: RateReasonSchema,
})
    .and(RateLeadTimeOverrideSchema);
export const AdminFacilityBillRateOverrideDeprecateRequestSchema = z
    .object({
    effectiveTo: RateIsoDateSchema,
    reason: RateReasonSchema,
})
    .and(RateLeadTimeOverrideSchema);
// v0/rate-provenance Phase 4 — in-place edit of an UNUSED facility bill-rate
// override. The identity tuple (facilityId, roleId, setting, shiftTimeBucket) +
// effective dates stay frozen, so only the overridden bill rate is editable. No
// reason / lead-time / audit. Server-gated to inUse=false.
export const AdminFacilityBillRateOverrideEditRequestSchema = z.object({
    billRateOverride: RateMoneyAmountSchema,
});
export const AdminFacilityBillRateOverrideResponseSchema = z.object({
    id: z.string().uuid(),
    facilityId: z.string().uuid(),
    facilityName: z.string(),
    roleId: z.string().uuid(),
    roleCode: z.string(),
    setting: ShiftSettingSchema,
    shiftTimeBucket: ShiftTimeBucketSchema.nullable(),
    billRateOverride: z.string(),
    effectiveFrom: RateIsoDateSchema,
    effectiveTo: RateIsoDateSchema.nullable(),
    isCurrent: z.boolean(),
    // v0/rate-provenance — has this row priced any shift? Drives the admin panel's
    // Edit/Delete (unused) vs Supersede/Deprecate (used) action split.
    inUse: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const AdminFacilityBillRateOverrideListQuerySchema = z.object({
    facilityId: z.string().uuid().optional(),
    roleId: z.string().uuid().optional(),
    setting: ShiftSettingSchema.optional(),
    includeHistorical: z.coerce.boolean().default(false),
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(100).default(20),
});
export const AdminFacilityBillRateOverrideListResponseSchema = z.object({
    items: z.array(AdminFacilityBillRateOverrideResponseSchema),
    totalCount: z.number().int().min(0),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
//# sourceMappingURL=facility-bill-rate-override-admin.schema.js.map